import { Box, Flex } from '@gazin/ecommerce-ui'

type RichContentInfoProps = {
  brandSlug?: string
  manufacturerCode?: string
}

export const RichContentInfo = ({
  brandSlug,
  manufacturerCode,
}: RichContentInfoProps) => {
  return (
    <Flex
      flexDir="column"
      width="100%"
      maxW="81.875rem"
      padding="0 0.938rem"
      marginX="auto"
    >
      <Box id="syndi_inline" width="100%" data-testid="syndigo-content" />

      {brandSlug && (
        <Box display="none" id="marca_slug" data-testid="brand-slug">
          {brandSlug}
        </Box>
      )}

      {manufacturerCode && (
        <Box
          display="none"
          id="codigo_fabricante"
          data-testid="manufacturer-code"
        >
          {manufacturerCode.trim()}
        </Box>
      )}

      <Box id="ccs-inline-content" width="100%" data-testid="1ws-content" />
    </Flex>
  )
}
